/*
	Puts something in an array if it is not array.
	Made because we support things a schema where one or more items may be tested.
*/
/**
 *
 * @param {*} item - The thing you want to put in an array
 * @returns The item in an array if it's not already an array. This was made because there are a few places
 * in this widget where we support thing1: '{}' or thing2: [{},{}] and we just turn the thing1 into an array
 * in the code before moving on.
 */
const putInArrayIfNotInArray = (item) => (Array.isArray(item) ? item : [item]);

export default putInArrayIfNotInArray;
